import {createContext} from 'react';
const ExpenseContext = createContext();
export default ExpenseContext;